module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-8506af.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
// module id = 790
// module chunks = 2